import { OperationType } from '@rematter/frontend-lib-api-client';

import { DefaultPriceListRecord } from '../types/pricing';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const defaultPriceListGetOrCreateMutationAtom =
  createMutationAtomFactory(
    'brokerage.defaultPriceListGetOrCreate',
    (params: {
      facilityId: string;
      operationType: OperationType;
      currency: string;
    }) => ({
      pricingDefaultPriceListGetOrCreate: {
        __args: {
          facilityId: params.facilityId,
          operationType: params.operationType,
          currency: params.currency,
        },
        id: true,
        facilityId: true,
        operationType: true,
        currency: true,
        notes: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    }),
    {
      select: (data): DefaultPriceListRecord | null => {
        const list = data?.pricingDefaultPriceListGetOrCreate;
        if (!list) return null;

        return {
          id: list.id,
          facilityId: list.facilityId,
          operationType: list.operationType as OperationType,
          currency: list.currency,
          notes: list.notes ?? null,
          timestamps: {
            createdAt: parseZonedDateTime(list.timestamps.createdAt),
            updatedAt: parseZonedDateTime(list.timestamps.updatedAt),
          },
        };
      },
    },
  );
